// extracted by mini-css-extract-plugin
export default {"rewardContainer":"RewardsContainer_rewardContainer__VFRB-"};